import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { colors } from '../../constants';

const Wrapper = styled.div`
  align-items: center;
  background: #ededed;
  display: flex;
  justify-content: center;
  width: 50%;
`;

const LoginFormWrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 60%;
  @media(max-width: 1440px) {
    width: 75%;
  }
`;

const FormHeader = styled.div`
  align-items: center;
  background: ${colors.purpleDark};
  border-top-left-radius: 2px;
  border-top-right-radius: 2px;
  box-shadow: 0px 1px 7px 0px rgba(0, 0, 0, 0.44);
  box-shadow: inset 1px 1px 2px 0px rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  height: 20vh;
  text-transform: uppercase;
`;

const FormContent = styled.form`
  background: white
  box-shadow: 0px 1px 7px 0px rgba(0,0,0,0.44);
  box-sizing: border-box;
  border-bottom-left-radius: 3px;
  border-bottom-right-radius: 3px;
  display: flex;
  flex-direction: column;
  padding: 0 15px 0 15px;
  width: 100%;
  `;

const SignIn = styled.h2`
  color: ${colors.purpleDark};
`;

const Submit = styled.input.attrs({
  type: 'submit',
  value: 'Sign in',
})`
  align-items: center;
  align-self: flex-end;
  background: ${colors.purpleDark};
  border-radius: 3px;
  border: none;
  box-shadow: 1px 1px 3px 1px rgba(0, 0, 0, 0.38);
  color: white;
  cursor: pointer;
  display: flex;
  font-size: 1em;
  justify-content: center;
  outline: none;
  text-transform: uppercase;
  padding: 1em;
`;

const Label = styled.label`
  color: gray;
  font-size: 1em;
  margin-bottom: 0.4em;
`;

const Logo = styled.span`
  color: white;
  font-size: 5vw;
`;

const MessageSubmitWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1em 0;
`;

const MessageWrapper = styled.div`
  width: 20em;
  height: 4em;
  display: flex;
  align-items: center;
`;

const LoginForm = (props) => {
  const {
    email,
    password,
    handleInputChange,
    handleSubmit,
    notification,
  } = props;

  const getNotification = (receivedNotification) => (
    receivedNotification !== null ? (
      <React.Fragment>
        <div>
          <b>{receivedNotification.title && receivedNotification.title}</b>
          <br />
          <span>{receivedNotification.message && receivedNotification.message}</span>
        </div>
      </React.Fragment>
    ) : (
      receivedNotification
    )
  );

  return (
    <Wrapper>
      <LoginFormWrapper>
        <FormHeader>
          <Logo>Cadess</Logo>
        </FormHeader>
        <FormContent onSubmit={(e) => handleSubmit(e)}>
          <SignIn>Sign in</SignIn>
          <Label>Email</Label>
          <input
            className="input-login"
            name="email"
            type="email"
            value={email}
            onChange={(e) => handleInputChange(e)}
          />
          <Label>Password</Label>
          <input
            className="input-login"
            name="password"
            type="password"
            value={password}
            onChange={(e) => handleInputChange(e)}
          />
          <MessageSubmitWrapper>
            <MessageWrapper>
              {getNotification(notification)}
            </MessageWrapper>
            <Submit />
          </MessageSubmitWrapper>
        </FormContent>
      </LoginFormWrapper>
    </Wrapper>
  );
};

LoginForm.propTypes = {
  email: PropTypes.string.isRequired,
  password: PropTypes.string.isRequired,
  handleInputChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
};

export default LoginForm;
